import Vue from 'vue'
import App from './App.vue'

// plugins
import VueScrollProgressBar from 'vue-scroll-progressbar'

// use
Vue.use(VueScrollProgressBar)

Vue.config.productionTip = false

// Expose a getter for $bus
Vue.prototype.$bus = new Vue()

// generic transitions functional component
require('@/transitions')

new Vue({
  render: h => h(App),
}).$mount('#app')
